import { SlotType } from './SlotType';

export class Slot {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly description: string | null,
    private readonly slotType: SlotType,
    private readonly tags: string[],
    private readonly atCapacity: boolean
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getSlotType() {
    return this.slotType;
  }

  getTags() {
    return this.tags;
  }

  isAtCapacity() {
    return this.atCapacity;
  }
}
